/**
 * @generated SignedSource<<af9423d6e9c6f4b72fde89655303e6b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceOverviewRefetchQuery$variables = {
  id: string;
  loadData?: boolean | null | undefined;
  reportcurrency?: string | null | undefined;
};
export type PerformanceOverviewRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverview_component">;
  } | null | undefined;
};
export type PerformanceOverviewRefetchQuery = {
  response: PerformanceOverviewRefetchQuery$data;
  variables: PerformanceOverviewRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "loadData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportcurrency"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "kind": "Variable",
  "name": "reportcurrency",
  "variableName": "reportcurrency"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PerformanceOverviewRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "loadData",
                "variableName": "loadData"
              },
              (v4/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "PerformanceOverview_component"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "FundServiceQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PerformanceOverviewRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "header",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "disclaimer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "staticDisclaimer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PerformanceOverviewInfo",
                "kind": "LinkedField",
                "name": "info",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentperformancetext",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentbenchmarktext",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paperformancetext",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pabenchmarktext",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "PerformanceOverviewMenu",
                "kind": "LinkedField",
                "name": "menu",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencySelectionSaveButtonText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencySelectionInfo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencySelectionHeader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "xlsdownloadtext",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SelectBox",
                    "kind": "LinkedField",
                    "name": "currencySelectBox",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SelectBoxItem",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "data",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "loadData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PerformanceOverviewChart",
                    "kind": "LinkedField",
                    "name": "chart",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "PerformanceChartData",
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "performance",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "benchmark",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PerformanceOverviewDatepicker",
                        "kind": "LinkedField",
                        "name": "datepicker",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "presetdatetexts",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "headercols",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "savebuttontext",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "datepickerbuttontexts",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "type": "PerformanceOverview",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9269f6b9c01d61135131a8d7676c6940",
    "id": null,
    "metadata": {},
    "name": "PerformanceOverviewRefetchQuery",
    "operationKind": "query",
    "text": "query PerformanceOverviewRefetchQuery(\n  $loadData: Boolean = false\n  $reportcurrency: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...PerformanceOverview_component_2dvJpD\n    id\n  }\n}\n\nfragment Datepicker_text on PerformanceOverviewDatepicker {\n  presetdatetexts\n  headercols\n  savebuttontext\n}\n\nfragment PerformanceOverviewChart_chart on PerformanceOverviewChart {\n  datepicker {\n    ...Datepicker_text\n    id\n  }\n  datepickerbuttontexts\n}\n\nfragment PerformanceOverviewCurrencySelection_currencySelection on SelectBox {\n  ...Selectbox_selectBox\n}\n\nfragment PerformanceOverviewInfo_data on PerformanceOverviewInfo {\n  currentperformancetext\n  currentbenchmarktext\n  paperformancetext\n  pabenchmarktext\n}\n\nfragment PerformanceOverviewMenu_menu on PerformanceOverviewMenu {\n  xlsdownloadtext\n  currencySelectionInfo\n  currencySelectionHeader\n  currencySelectionSaveButtonText\n}\n\nfragment PerformanceOverviewNumbers_data on PerformanceOverviewInfo {\n  currentperformancetext\n  currentbenchmarktext\n  paperformancetext\n  pabenchmarktext\n}\n\nfragment PerformanceOverview_component_2dvJpD on PerformanceOverview {\n  id\n  header\n  disclaimer\n  staticDisclaimer\n  chart @include(if: $loadData) {\n    id\n    data(reportcurrency: $reportcurrency) {\n      performance\n      benchmark\n      date\n    }\n    ...PerformanceOverviewChart_chart\n  }\n  info {\n    ...PerformanceOverviewNumbers_data\n    ...PerformanceOverviewInfo_data\n    id\n  }\n  menu(reportcurrency: $reportcurrency) {\n    currencySelectionSaveButtonText\n    currencySelectionInfo\n    currencySelectionHeader\n    ...PerformanceOverviewMenu_menu\n    currencySelectBox {\n      ...PerformanceOverviewCurrencySelection_currencySelection\n    }\n  }\n}\n\nfragment Selectbox_selectBox on SelectBox {\n  options {\n    key\n    label\n    data\n  }\n}\n"
  }
};
})();

(node as any).hash = "95db4d2947721b6fcb7fd106739da736";

export default node;
